export const RENDER_METHOD: {
    route: string;
    tabs: string;
} = {
    route: 'route',
    tabs: 'tabs'
} 